import { Injectable } from '@angular/core';
import { OneSignal } from '@ionic-native/onesignal/ngx';

@Injectable()
export class PushNotificationsService {
  private isOneSignalInitialized = false;
  constructor(private oneSignal: OneSignal) {}

  public initializeOneSignal(oneSignalAppId: string, firebaseProjectNumber: string): void {
    // Check if OneSignal has already been initialized
    if (this.isOneSignalInitialized) {
      console.warn('OneSignal has already been initialized.');
      return;
    }
    this.oneSignal.startInit(oneSignalAppId, firebaseProjectNumber);
    this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.InAppAlert);
    this.oneSignal.handleNotificationReceived().subscribe((res) => {
      // do something when notification is received
      console.log(res);
    });

    this.oneSignal.handleNotificationOpened().subscribe((res) => {
      // do something when a notification is opened
      console.log(res);
    });

    this.oneSignal.endInit();
    // Set the flag to indicate that initialization is complete
    this.isOneSignalInitialized = true;
  }
}
